import React from "react";

const NotFound = () => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      backgroundColor: "#f8f9fa",
      textAlign: "center",
    },
    heading: {
      fontSize: "3rem",
      color: "#dc3545",
      marginBottom: "0.5rem",
    },
    paragraph: {
      fontSize: "1.25rem",
      marginBottom: "1.5rem",
      color: "#6c757d",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404 Not Found</h1>
      <p style={styles.paragraph}>
        The page you are looking for does not exist.
      </p>
    </div>
  );
};

export default NotFound;
